import { Container } from 'reactstrap';
import CampsitesList from '../features/campsites/CampsitesList';
import SubHeader from '../components/SubHeader';


/* component CampsitesDirectoryPage ..................................................................................... [START] */
const CampsitesDirectoryPage = () => {

  /* JSX code ................................................................................................. [START] */
  return (
    /* container .................................................................................... [START] */
    <Container>
      <SubHeader current='Directory' />
      <CampsitesList />
    </Container>
    /* container ...................................................................................... [END] */
  );
  /* JSX code ................................................................................................... [END] */
};

export default CampsitesDirectoryPage;
/* component CampsitesDirectoryPage ....................................................................................... [END] */